import React from "react";

import Box from "../Box";

const Three = props => {
  return (
    <section className="hp__block hp__block--three container">
      <div className="row hp__block__row hp__block__row--first">
        <Box
          {...props}
          id="b1"
          type="news"
          settings={props.settings.b1}
          classes="col-xs-6 col-md-4"
        />
        <Box
          {...props}
          id="b2"
          type="news"
          settings={props.settings.b2}
          classes="col-xs-6 col-md-4 hp__box__xs__right"
        />
        <Box
          {...props}
          id="b3"
          type="news"
          settings={props.settings.b3}
          classes="col-xs-12 col-md-4"
        />
      </div>
    </section>
  );
};

export default Three;
